import * as React from 'react';
import { Text } from 'wix-ui-tpa';
import { classes } from './ExpandedTitle.st.css';
var ExpandedTitle = function (_a) {
    var eventColor = _a.eventColor, title = _a.title;
    return (React.createElement("div", { className: classes.ExpandedTitleContainer, style: { borderLeft: "2px solid ".concat(eventColor) } },
        React.createElement(Text, { className: classes.ExpandedTitle }, title)));
};
export default React.memo(ExpandedTitle);
//# sourceMappingURL=ExpandedTitle.js.map